<div class="dialog-header">
  <div class="dialog-title">
    {{ translationService.getCompaniesText() }}
    @if (data.companyName) {
      <span>- {{ data.companyName }}</span>
    }
  </div>

  <button mat-icon-button type="button" (click)="close()" aria-label="Close">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div class="dialog-body">
  @if (errorMessage) {
    <div class="dialog-error">
      {{ errorMessage }}
    </div>
  }

  <div class="dialog-section">
    <h3 class="section-title">
      {{ translationService.getAddConnectionText() }}
    </h3>

    <mat-form-field appearance="outline" class="search-field">
      <mat-label>{{ translationService.getCompanyNameText() }}</mat-label>
      <input
        matInput
        type="text"
        name="searchName"
        [(ngModel)]="searchName"
        (ngModelChange)="onSearchNameChange($event)"
        [matAutocomplete]="auto"
        minlength="2"
      />

      <mat-autocomplete
        #auto="matAutocomplete"
        (optionSelected)="onCompanySelected($event.option.value)"
      >
        @for (c of suggestions; track c) {
          <mat-option [value]="c">
            {{ c.name }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>

    @if (searchName.trim().length >= 2 && suggestions.length === 0) {
      <div class="empty">
        {{ translationService.getNoResultsText() }}
      </div>
    }
  </div>

  <div class="dialog-section">
    <h3 class="section-title">{{ translationService.getConnectionsText() }}</h3>

    @if (connectionsDataSource.data.length === 0) {
      <div class="empty">No connections</div>
    }

    @if (connectionsDataSource.data.length > 0) {
      <table mat-table [dataSource]="connectionsDataSource">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>
            {{ translationService.getNameText() }}
          </th>
          <td mat-cell *matCellDef="let row">{{ row.name }}</td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>
            {{ translationService.getStatusText() }}
          </th>
          <td mat-cell *matCellDef="let row">
            {{
              row.is_active
                ? translationService.getActiveText()
                : translationService.getInactiveText()
            }}
          </td>
        </ng-container>
        <ng-container matColumnDef="remove">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row" class="right">
            <button
              mat-stroked-button
              color="warn"
              type="button"
              (click)="removeConnection(row.id)"
            >
              <mat-icon>delete</mat-icon>
              {{ translationService.getRemoveText() }}
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    }
  </div>
</div>

<div class="dialog-footer">
  <button mat-stroked-button type="button" (click)="close()">
    {{ translationService.getCloseText() }}
  </button>
</div>
